"use strict";
angular.module('manageSysManageCategoryLibraryManageModule', [
        'publicLibraryCategoryServiceModule'
    ])
    .controller('manageSysManageCategoryLibraryManageCtrl', ['$scope', '$state', '$q', 'trsHttpService', 'publicLibraryCategoryService', 'modalDialog', 'trsspliceString', '$stateParams', function($scope, $state, $q, trsHttpService, publicLibraryCategoryService, modalDialog, trsspliceString, $stateParams) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1,
                "copyCurrPage": 1,
            };

            $scope.status = {
                parentName: $stateParams.categoryname
            };

            $scope.data = {
                items: [],
                selectedArray: [],
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [newCategory 新建公共素材库]
         * @return {[type]} [description]
         */
        $scope.newCategory = function() {
            getAllType().then(function(data) {
                var params = {
                    SHARECATEGORYID: 0,
                    // MODALID: 38,
                    GAOKUCATEGORYNAME: $state.params.categoryname,
                    zuiqian: data,
                    ParentId: $state.params.sharecategoryid,
                    isSecondClassify: true,
                };
                newAndEditCategory(params, '新建');
            });
        };

        /**
         * [modify 修改]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.modify = function(item) {
            getAllType().then(function(data) {
                item.zuiqian = data;
                item.GAOKUCATEGORYNAME = $state.params.categoryname;
                item.ParentId = $state.params.sharecategoryid;
                item.isSecondClassify = true;
                newAndEditCategory(item, '修改');
            });
        };

        /**
         * [getAllType 获取所有类型]
         * @return {[type]} [description]
         */
        function getAllType() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_sharedmaterial',
                methodname: 'queryCategorysByParentId',
                ParentId: $state.params.sharecategoryid,
                IsAll: true,
                CURRPAGE: $scope.page.CURRPAGE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                defer.resolve(data.DATA);
            });
            return defer.promise;
        }

        /**
         * [requestData 获取数据]
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: 'mlf_sharedmaterial',
                methodname: 'queryCategorysByParentId',
                ParentId: $state.params.sharecategoryid,
                IsAll: true,
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
                $scope.page.copyCurrPage = $scope.page.CURRPAGE;
            });
        }

        /**
         * [newAndEditCategory 新建修改公共素材库]
         * @param  {[type]} edit [description]
         * @return {[type]}      [description]
         */
        function newAndEditCategory(item, type) {
            publicLibraryCategoryService.newPublicLibraryCategory(item).then(function(result) {
                var params = {
                    serviceid: 'mlf_sharedmaterial',
                    methodname: 'saveCategory',
                    CategoryId: result.SHARECATEGORYID,
                    CategoryName: result.CATEGORYNAME,
                    Status: result.STATUS,
                    ParentId: !!item.ParentId ? item.ParentId : 0,
                    // ModalId: 38,
                    Corder: result.CORDER,
                    VisibleCategorys: result.VISIBLECATEGORYS,
                    ISMEIZIDEFAULTPATH: result.ISMEIZIDEFAULTPATH,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (!!data && data.ISSUCCESS === 'true') {
                        modalDialog.alertType(type + '公共素材库类别成功', '', 'success', false, function() {
                            requestData();
                        });
                    }
                });
            });
        }

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.items.length === $scope.data.selectedArray.length && $scope.data.items.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [];
                for (let i = 0; i < $scope.data.items.length; i++) {
                    $scope.data.selectedArray.push($scope.data.items[i]);
                }
            }
        };

        /**
         * [delete 删除公共素材库]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.delete = function(item) {
            var params = {
                serviceid: 'mlf_sharedmaterial',
                methodname: 'deleteCategory',
                CategoryIds: !!item ? item.SHARECATEGORYID : trsspliceString.spliceString($scope.data.selectedArray, 'SHARECATEGORYID', ',')
            };
            modalDialog.confirmModal('删除', '是否确定删除所选公共素材库？', function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS === 'true') {
                        modalDialog.alertType('删除成功', '', 'success', false, function() {
                            $scope.data.selectedArray = [];
                            requestData();
                        });
                    }
                });
            });
        };

        /**
         * [backgToPublicMaterial 返回公共素材库]
         * @return {[type]} [description]
         */
        $scope.backgToPublicMaterial = function() {
            $state.go('manageconfig.sysmanage.publicmateriallibrary');
        };
    }]);